import { Wrapper, Copy, Logos, Logo, BankIdLogo, StripeLogo } from './PaymentSection.parts';

export function PaymentSection() {
	return (
		<Wrapper>
			<Copy>Säkra överföringar med</Copy>
			<Logos>
				<Logo uri="/assets/logos/trustly-badge/green.svg" alt="Trustly onlinebanköverföringar" />
				<BankIdLogo alt="BankID" />
				<StripeLogo alt="Stripe betalning" />
				<Logo uri="/assets/logos/swish/base.svg" alt="Swish betalningar" />
			</Logos>
		</Wrapper>
	);
}
